import Model from 'src/storage/base';
import AlertManager from 'components/alert';
import LANG_CONST from 'src/helpers/lang/const';
import { permissions, remCss } from 'src/helpers';
import constants from 'src/constants';
import moment from 'moment/moment';
import errorDescriptions from 'src/constants/errors';

export const STEPS = {
  GROUP_SLOTS: 'GROUP_SLOTS',
  SLOTS_OF_DAYS: 'SLOTS_OF_DAYS',
  GENERATE_SCHEDULE: 'GENERATE_SCHEDULE',
  BOOKED_LIST: 'BOOKED_LIST',
  RESCHEDULE: 'RESCHEDULE',
  BOOK: 'BOOK',
  SLOTS_OF_RANGE: 'SLOTS_OF_RANGE'
};

export class SlotScheduleMainModel extends Model {
  id = 'SlotScheduleMainModel';
  history = [];

  defaultState = () => ({});

  apiConfig = {
    removeSlot: {
      url: 'schedule/remove',
      validation: {
        slotId: 'string'
      },
      cancellable: false
    },
    saveSlot: {
      url: 'schedule/saveSlot',
      validation: {},
      cancellable: false
    },
    getSlots: {
      url: 'schedule/listAvailable',
      validation: {
        from: 'number',
        to: 'number'
      },
      cancellable: true
    }
  };
  _events = {
    profile: 'handleChangeProfileAndSwitchAccount'
  };

  setNextStep = (step, props) => {
    if (this.state.step) this.history.push(this.state.step);
    models[step].setStateSilent({ ...models[step].defaultState(), ...props });
    this.setState({ step });
  };

  canBackStep = () => {
    return this.history.length > 0;
  };

  backStep = (e) => {
    e?.preventDefault();
    const step = this.history.pop();
    if (models[model.state.step].state.onBack) {
      models[model.state.step].state.onBack();
    }
    this.setState({ step });
  };
  keepPreviousComponent = (step) => {
    return this.history.includes(step);
  };

  removeSlot = (slot, doctorId, cb) => {
    if (!this.checkModifiedPermission(slot)) return;

    AlertManager.popup(AlertManager.TYPES.WARN, {
      close: false,
      title: LANG_CONST.notice.delete,
      cancelButton: {
        label: LANG_CONST.buttons.no,
        action: (actions) => actions.hide()
      },
      actionButton: {
        label: LANG_CONST.buttons.yes,
        action: (actions) => {
          actions.setLoading(true);
          if (!slot.id) return console.warn('remove - missing slot id', slot);
          slot.removing = true;
          this.api(
            'removeSlot',
            { slotId: slot.id, doctorId: this.state.doctorId },
            (err, res, success) => {
              slot.removing = false;
              actions.setLoading(false);
              if (err) {
                AlertManager.popup(AlertManager.TYPES.WARN, {
                  close: false,
                  title: errorDescriptions(err),
                  actionButton: {
                    label: LANG_CONST.buttons.ok,
                    action: (actions) => {
                      actions.hide();
                    }
                  }
                });
              } else actions.hide();
              if (cb) cb(err, res, success);
            }
          );
        }
      }
    });
  };
  saveSlot = (params, cb) => {
    this.api('saveSlot', params, (error, data) => {
      cb(error, data);
    });
  };

  checkModifiedPermission = (item) => {
    if (!this.checkDoctorSelected()) return false;
    if (item && item.patientId > 0 && !this.checkMangerPermission()) return false;
    return this.canModify(item);
  };

  checkMangerPermission = () => {
    const { user } = model.getState();
    if (!user.isManager || user.managerAdmin) return true;

    if (user.managerAccess.filter((a) => a.appointments).length > 0) {
      return true;
    }

    AlertManager.popup(AlertManager.TYPES.INFO, {
      width: remCss(650),
      title: LANG_CONST.manager_no_permissions.appointments,
      actionButton: {
        label: LANG_CONST.buttons.ok,
        action: ({ hide }) => hide()
      }
    });

    return false;
  };

  canModify = (item) => {
    const { user } = this.state;
    const isOwner = item?.clinicId === user.id || user.isDoctor;
    const isAdmin = !!user.managerAdmin && user?.managerToClinic === item?.clinicId;
    const hospitalIds = user.managerAccess
      ?.filter((a) => !!a.appointments)
      .map((a) => a.hospitalId);

    const doctor = user.isDoctor ? user : this.state.doctor;

    return (
      user?.status !== constants.general.userStatus.disabled &&
      doctor?.status !== constants.general.userStatus.disabled &&
      (!item?.hospitalId || isOwner || isAdmin || hospitalIds?.includes(item.hospitalId))
    );
  };

  checkDoctorSelected = (doctor) => {
    const { user } = model.getState();
    doctor = doctor || model.state.doctor;
    if (user.isDoctor || doctor?.id) return true;

    AlertManager.popup(AlertManager.TYPES.INFO, {
      width: remCss(550),
      close: true,
      title: LANG_CONST.text.add_doctor_for_schedule,
      actionButton: {
        label: LANG_CONST.buttons.add_first_doctor,
        action: ({ hide }) => {
          model.emit('router_navigate', { url: permissions.PAGES.DOCTORS_ADD_PAGE.match() });
          hide();
        }
      }
    });

    return false;
  };

  getHospitalParams = () => {
    const params = {};

    if (model.state.user?.isDoctor) {
      params.url = 'hospital/list';
      if (model.state.user?.clinicIds?.length) {
        params.clinicIds = model.state.user?.clinicIds;
        params.hospitalIds = model.state.user?.hospitalIds;
      }
    } else {
      params.url = 'clinic/manager/hospitals';
      params.hospitalIds = model.state.doctor?.hospitalIds;
      params.activeAppointments = true;
    }

    return params;
  };

  getFees = () => {
    const { doctor, selectedSlot } = this.state;
    if (!doctor) return null;
    const feeType = doctor.chargePatientType || 'first';
    const charge =
      (doctor.charges || []).find((c) => c.id === selectedSlot?.hospitalId) || doctor.charge;
    return charge && charge[feeType];
  };

  getCurrency = () => {
    return this.state.doctor?.currency || null;
  };

  getSlots = (day, cb) => {
    const startDate = day ? moment(day) : moment();
    this.api(
      'getSlots',
      {
        id: this.state.doctorId,
        from: Math.max(startDate.startOf('month').valueOf(), moment().valueOf()),
        to: startDate.endOf('month').valueOf()
      },
      (err, res, success) => {
        cb && cb(err, res, success);
      }
    );
  };
}

export class SlotScheduleModel extends Model {
  id = 'SlotScheduleModel';
  defaultState = () => ({});

  constructor(id, defaultState) {
    super();
    if (id) this.id += '_' + id;
    this.defaultState = defaultState;
  }

  setStateInit = (state) => {
    this.setState({ ...this.defaultState(), ...state });
  };
}

export const models = {
  [STEPS.GROUP_SLOTS]: new SlotScheduleModel(STEPS.GROUP_SLOTS, () => ({
    onBack: null,
    onDone: null
  })),
  [STEPS.SLOTS_OF_DAYS]: new SlotScheduleModel(STEPS.SLOTS_OF_DAYS, () => ({
    slot: null,
    addHour: null,
    selectedDay: null,
    onBack: null,
    onDone: null
  })),
  [STEPS.GENERATE_SCHEDULE]: new SlotScheduleModel(STEPS.GENERATE_SCHEDULE, () => ({
    onBack: null,
    onDone: null
  })),
  [STEPS.BOOKED_LIST]: new SlotScheduleModel(STEPS.BOOKED_LIST, () => ({
    list: [],
    onSave: null,
    onBack: null,
    onDone: null
  })),
  [STEPS.RESCHEDULE]: new SlotScheduleModel(STEPS.RESCHEDULE, () => ({
    editId: null,
    editAppointmentId: null,
    selectedDay: null,
    type: null,
    onBack: null,
    onDone: null
  })),
  [STEPS.BOOK]: new SlotScheduleModel(STEPS.BOOK, () => ({
    slot: null,
    params: {},
    onBack: null,
    onDone: null
  })),
  [STEPS.SLOTS_OF_RANGE]: new SlotScheduleModel(STEPS.SLOTS_OF_RANGE, () => ({
    tab: 'free',
    item: null,
    parent: null,
    startDate: null,
    endDate: null,
    onBack: null,
    onDone: null
  }))
};

const model = new SlotScheduleMainModel();

export default model;
